import { Box } from '@mui/material';
import { LineSpinner } from 'ldrs/react';
import { colors } from '@sweep-io/sweep-design';
import 'ldrs/react/LineSpinner.css';

interface CenteredCircularProgressProps {
  size?: number;
  speed?: number;
  color?: string;
  minHeight?: string;
}

const CenteredCircularProgress = ({
  size = 30,
  speed = 1,
  color = 'primary',
  minHeight = '100%',
}: CenteredCircularProgressProps) => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
    <LineSpinner
      size={size}
      speed={speed}
      color={color === 'primary' ? colors.blue[500] : color}
      stroke={2}
    />
  </Box>
);

export { CenteredCircularProgress };
